"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var cov_1ejp08mtw9 = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repository/helpers.js";
  var hash = "68ba04bb73ad795db85b1d88eb72c8c7f301ecb7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repository/helpers.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 32
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 15
        },
        end: {
          line: 12,
          column: 88
        }
      },
      "2": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 23,
          column: 3
        }
      },
      "3": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "4": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "5": {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 47
        }
      },
      "6": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 22,
          column: 6
        }
      },
      "7": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 43
        }
      },
      "8": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 25
        }
      },
      "9": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "10": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 29,
          column: 6
        }
      },
      "11": {
        start: {
          line: 26,
          column: 26
        },
        end: {
          line: 26,
          column: 88
        }
      },
      "12": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 36
        }
      },
      "13": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 25
        }
      },
      "14": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 33,
          column: 4
        }
      },
      "15": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 42
        }
      },
      "16": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 36,
          column: 4
        }
      },
      "17": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 23
        }
      },
      "18": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 20
        }
      },
      "19": {
        start: {
          line: 40,
          column: 30
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "20": {
        start: {
          line: 41,
          column: 40
        },
        end: {
          line: 41,
          column: 50
        }
      },
      "21": {
        start: {
          line: 42,
          column: 19
        },
        end: {
          line: 42,
          column: 74
        }
      },
      "22": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 43,
          column: 18
        }
      },
      "23": {
        start: {
          line: 46,
          column: 31
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "24": {
        start: {
          line: 47,
          column: 40
        },
        end: {
          line: 47,
          column: 50
        }
      },
      "25": {
        start: {
          line: 48,
          column: 19
        },
        end: {
          line: 48,
          column: 73
        }
      },
      "26": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 49,
          column: 18
        }
      },
      "27": {
        start: {
          line: 52,
          column: 32
        },
        end: {
          line: 61,
          column: 1
        }
      },
      "28": {
        start: {
          line: 53,
          column: 20
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "29": {
        start: {
          line: 59,
          column: 19
        },
        end: {
          line: 59,
          column: 72
        }
      },
      "30": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 60,
          column: 18
        }
      },
      "31": {
        start: {
          line: 63,
          column: 30
        },
        end: {
          line: 66,
          column: 1
        }
      },
      "32": {
        start: {
          line: 64,
          column: 19
        },
        end: {
          line: 64,
          column: 56
        }
      },
      "33": {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 65,
          column: 18
        }
      },
      "34": {
        start: {
          line: 68,
          column: 40
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "35": {
        start: {
          line: 69,
          column: 40
        },
        end: {
          line: 69,
          column: 50
        }
      },
      "36": {
        start: {
          line: 70,
          column: 19
        },
        end: {
          line: 70,
          column: 84
        }
      },
      "37": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 71,
          column: 18
        }
      },
      "38": {
        start: {
          line: 74,
          column: 32
        },
        end: {
          line: 78,
          column: 1
        }
      },
      "39": {
        start: {
          line: 75,
          column: 40
        },
        end: {
          line: 75,
          column: 50
        }
      },
      "40": {
        start: {
          line: 76,
          column: 19
        },
        end: {
          line: 76,
          column: 84
        }
      },
      "41": {
        start: {
          line: 77,
          column: 2
        },
        end: {
          line: 77,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 32
          },
          end: {
            line: 11,
            column: 33
          }
        },
        loc: {
          start: {
            line: 11,
            column: 92
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 35
          },
          end: {
            line: 14,
            column: 36
          }
        },
        loc: {
          start: {
            line: 14,
            column: 41
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 19,
            column: 23
          }
        },
        loc: {
          start: {
            line: 19,
            column: 28
          },
          end: {
            line: 22,
            column: 5
          }
        },
        line: 19
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 25,
            column: 24
          },
          end: {
            line: 25,
            column: 25
          }
        },
        loc: {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 29,
            column: 5
          }
        },
        line: 25
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 31,
            column: 21
          },
          end: {
            line: 31,
            column: 22
          }
        },
        loc: {
          start: {
            line: 31,
            column: 27
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 31
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 34,
            column: 21
          },
          end: {
            line: 34,
            column: 22
          }
        },
        loc: {
          start: {
            line: 34,
            column: 27
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 34
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 40,
            column: 30
          },
          end: {
            line: 40,
            column: 31
          }
        },
        loc: {
          start: {
            line: 40,
            column: 62
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 40
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 46,
            column: 31
          },
          end: {
            line: 46,
            column: 32
          }
        },
        loc: {
          start: {
            line: 46,
            column: 63
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 46
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 52,
            column: 32
          },
          end: {
            line: 52,
            column: 33
          }
        },
        loc: {
          start: {
            line: 52,
            column: 68
          },
          end: {
            line: 61,
            column: 1
          }
        },
        line: 52
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 63,
            column: 30
          },
          end: {
            line: 63,
            column: 31
          }
        },
        loc: {
          start: {
            line: 63,
            column: 63
          },
          end: {
            line: 66,
            column: 1
          }
        },
        line: 63
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 68,
            column: 40
          },
          end: {
            line: 68,
            column: 41
          }
        },
        loc: {
          start: {
            line: 68,
            column: 82
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 68
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 74,
            column: 32
          },
          end: {
            line: 74,
            column: 33
          }
        },
        loc: {
          start: {
            line: 74,
            column: 74
          },
          end: {
            line: 78,
            column: 1
          }
        },
        line: 74
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 15
          },
          end: {
            line: 12,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 12,
            column: 57
          },
          end: {
            line: 12,
            column: 76
          }
        }, {
          start: {
            line: 12,
            column: 79
          },
          end: {
            line: 12,
            column: 88
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 16
          },
          end: {
            line: 12,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 16
          },
          end: {
            line: 12,
            column: 30
          }
        }, {
          start: {
            line: 12,
            column: 34
          },
          end: {
            line: 12,
            column: 53
          }
        }],
        line: 12
      },
      "2": {
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }, {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }],
        line: 13
      },
      "3": {
        loc: {
          start: {
            line: 13,
            column: 6
          },
          end: {
            line: 13,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 13,
            column: 6
          },
          end: {
            line: 13,
            column: 10
          }
        }, {
          start: {
            line: 13,
            column: 14
          },
          end: {
            line: 13,
            column: 57
          }
        }],
        line: 13
      },
      "4": {
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        }, {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        }],
        line: 24
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "68ba04bb73ad795db85b1d88eb72c8c7f301ecb7"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteRepository = exports.updateRepositorySettings = exports.readRepository = exports.createRepository = exports.repositoryForks = exports.forkRepository = exports.extendRepository = void 0;

var _core = require("../../core");

cov_1ejp08mtw9.s[0]++;

var extendRepository = function extendRepository(_ref) {
  var repository = _ref.repository,
      authentication = _ref.authentication,
      updateRepository = _ref.updateRepository,
      config = _ref.config;
  cov_1ejp08mtw9.f[0]++;
  var user = (cov_1ejp08mtw9.s[1]++, (cov_1ejp08mtw9.b[1][0]++, authentication) && (cov_1ejp08mtw9.b[1][1]++, authentication.user) ? (cov_1ejp08mtw9.b[0][0]++, authentication.user) : (cov_1ejp08mtw9.b[0][1]++, undefined));
  cov_1ejp08mtw9.s[2]++;

  if ((cov_1ejp08mtw9.b[3][0]++, user) && (cov_1ejp08mtw9.b[3][1]++, user.username === repository.owner.username)) {
    cov_1ejp08mtw9.b[2][0]++;
    cov_1ejp08mtw9.s[3]++;

    repository.dangerouslyDelete = function () {
      cov_1ejp08mtw9.f[1]++;
      cov_1ejp08mtw9.s[4]++;
      deleteRepository({
        repository: repository,
        config: config
      });
      cov_1ejp08mtw9.s[5]++;
      window.setTimeout(updateRepository, 500);
    };
  } else {
    cov_1ejp08mtw9.b[2][1]++;
    cov_1ejp08mtw9.s[6]++;

    repository.fork = function () {
      cov_1ejp08mtw9.f[2]++;
      cov_1ejp08mtw9.s[7]++;
      forkRepository({
        repository: repository,
        config: config
      });
      cov_1ejp08mtw9.s[8]++;
      updateRepository();
    };
  }

  cov_1ejp08mtw9.s[9]++;

  if (repository.permissions.admin) {
    cov_1ejp08mtw9.b[4][0]++;
    cov_1ejp08mtw9.s[10]++;

    repository.update = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(settings) {
        var _repository;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cov_1ejp08mtw9.f[3]++;
                cov_1ejp08mtw9.s[11]++;
                _context.next = 4;
                return updateRepositorySettings({
                  repository: repository,
                  settings: settings,
                  config: config
                });

              case 4:
                _repository = _context.sent;
                cov_1ejp08mtw9.s[12]++;
                updateRepository(_repository);
                cov_1ejp08mtw9.s[13]++;
                return _context.abrupt("return", _repository);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
  } else {
    cov_1ejp08mtw9.b[4][1]++;
  }

  cov_1ejp08mtw9.s[14]++;

  repository.forks = function () {
    cov_1ejp08mtw9.f[4]++;
    cov_1ejp08mtw9.s[15]++;
    repositoryForks({
      repository: repository,
      config: config
    });
  };

  cov_1ejp08mtw9.s[16]++;

  repository.close = function () {
    cov_1ejp08mtw9.f[5]++;
    cov_1ejp08mtw9.s[17]++;
    updateRepository();
  };

  cov_1ejp08mtw9.s[18]++;
  return repository;
};

exports.extendRepository = extendRepository;
cov_1ejp08mtw9.s[19]++;

var forkRepository = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var repository, config, _ref5, username, name, response;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            repository = _ref3.repository, config = _ref3.config;
            cov_1ejp08mtw9.f[6]++;
            _ref5 = (cov_1ejp08mtw9.s[20]++, repository), username = _ref5.owner.username, name = _ref5.name;
            cov_1ejp08mtw9.s[21]++;
            _context2.next = 6;
            return (0, _core.createFork)({
              owner: username,
              repo: name,
              config: config
            });

          case 6:
            response = _context2.sent;
            cov_1ejp08mtw9.s[22]++;
            return _context2.abrupt("return", response);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function forkRepository(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.forkRepository = forkRepository;
cov_1ejp08mtw9.s[23]++;

var repositoryForks = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
    var repository, config, _ref8, username, name, response;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            repository = _ref6.repository, config = _ref6.config;
            cov_1ejp08mtw9.f[7]++;
            _ref8 = (cov_1ejp08mtw9.s[24]++, repository), username = _ref8.owner.username, name = _ref8.name;
            cov_1ejp08mtw9.s[25]++;
            _context3.next = 6;
            return (0, _core.readForks)({
              owner: username,
              repo: name,
              config: config
            });

          case 6:
            response = _context3.sent;
            cov_1ejp08mtw9.s[26]++;
            return _context3.abrupt("return", response);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function repositoryForks(_x3) {
    return _ref7.apply(this, arguments);
  };
}();

exports.repositoryForks = repositoryForks;
cov_1ejp08mtw9.s[27]++;

var createRepository = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref9) {
    var repo, settings, config, _settings, response;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            repo = _ref9.repo, settings = _ref9.settings, config = _ref9.config;
            cov_1ejp08mtw9.f[8]++;
            _settings = (cov_1ejp08mtw9.s[28]++, _objectSpread({
              name: repo,
              description: "".concat(repo, " created via API."),
              private: false
            }, settings));
            cov_1ejp08mtw9.s[29]++;
            _context4.next = 6;
            return (0, _core.createRepo)({
              repo: repo,
              settings: _settings,
              config: config
            });

          case 6:
            response = _context4.sent;
            cov_1ejp08mtw9.s[30]++;
            return _context4.abrupt("return", response);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function createRepository(_x4) {
    return _ref10.apply(this, arguments);
  };
}();

exports.createRepository = createRepository;
cov_1ejp08mtw9.s[31]++;

var readRepository = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref11) {
    var owner, repo, config, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            owner = _ref11.owner, repo = _ref11.repo, config = _ref11.config;
            cov_1ejp08mtw9.f[9]++;
            cov_1ejp08mtw9.s[32]++;
            _context5.next = 5;
            return (0, _core.readRepo)({
              owner: owner,
              repo: repo,
              config: config
            });

          case 5:
            response = _context5.sent;
            cov_1ejp08mtw9.s[33]++;
            return _context5.abrupt("return", response);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function readRepository(_x5) {
    return _ref12.apply(this, arguments);
  };
}();

exports.readRepository = readRepository;
cov_1ejp08mtw9.s[34]++;

var updateRepositorySettings = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref13) {
    var repository, settings, config, _ref15, username, name, response;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            repository = _ref13.repository, settings = _ref13.settings, config = _ref13.config;
            cov_1ejp08mtw9.f[10]++;
            _ref15 = (cov_1ejp08mtw9.s[35]++, repository), username = _ref15.owner.username, name = _ref15.name;
            cov_1ejp08mtw9.s[36]++;
            _context6.next = 6;
            return (0, _core.updateRepo)({
              owner: username,
              repo: name,
              settings: settings,
              config: config
            });

          case 6:
            response = _context6.sent;
            cov_1ejp08mtw9.s[37]++;
            return _context6.abrupt("return", response);

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function updateRepositorySettings(_x6) {
    return _ref14.apply(this, arguments);
  };
}();

exports.updateRepositorySettings = updateRepositorySettings;
cov_1ejp08mtw9.s[38]++;

var deleteRepository = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref16) {
    var repository, settings, config, _ref18, username, name, response;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            repository = _ref16.repository, settings = _ref16.settings, config = _ref16.config;
            cov_1ejp08mtw9.f[11]++;
            _ref18 = (cov_1ejp08mtw9.s[39]++, repository), username = _ref18.owner.username, name = _ref18.name;
            cov_1ejp08mtw9.s[40]++;
            _context7.next = 6;
            return (0, _core.deleteRepo)({
              owner: username,
              repo: name,
              settings: settings,
              config: config
            });

          case 6:
            response = _context7.sent;
            cov_1ejp08mtw9.s[41]++;
            return _context7.abrupt("return", response);

          case 9:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function deleteRepository(_x7) {
    return _ref17.apply(this, arguments);
  };
}();

exports.deleteRepository = deleteRepository;